/**
 * Битовая сумма всех открытых типов кузова
 */
export const openCarTypes = '70368744191104';

/**
 * Битовая сумма всех закрытых типов кузова
 */
export const closeCarTypes = '844424930132063';
